import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.date.to-string";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import { __assign, __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import TariffBinllingList from './components/tariffBinllingList.vue';
import BinllingList from './components/binllingList.vue';
import TransportBinllingList from "@/views/finance/billing/components/transportBinllingList.vue";

var BillingListCompsitePage = function (_super) {
  __extends(BillingListCompsitePage, _super);

  function BillingListCompsitePage() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.activeTab = '';
    return _this;
  }

  Object.defineProperty(BillingListCompsitePage.prototype, "showTabList", {
    get: function get() {
      var tabList = [{
        text: this.tc('转运物流'),
        value: 'transportBinllingList',
        _permissionKey: 'action_transport_binlling_list'
      }, {
        text: this.tc('关税代收代付'),
        value: 'tariffBinllingList',
        _permissionKey: 'action_tariff_binlling_list'
      }];

      if (this.$util.checkContractedBusiness([this.$enum.mine.ContractTypeEnum.OVERSEA_LOCATION, this.$enum.mine.ContractTypeEnum.TRANSIT_LOCATION, this.$enum.mine.ContractTypeEnum.TARIFF])) {
        tabList.unshift({
          text: this.tc('海外仓储&中转代发'),
          value: 'binllingList'
        });
      }

      return this.$util.filterListPermission(tabList);
    },
    enumerable: false,
    configurable: true
  });

  BillingListCompsitePage.prototype.handleChange = function (value) {
    this.activeTab = value;
    this.$router.push({
      name: 'BillingListCompsitePage',
      query: __assign(__assign({}, this.$route.query), {
        pageType: value
      })
    });
  };

  BillingListCompsitePage.prototype.handleSwitchTab = function (componentName) {
    this.activeTab = componentName;
  };

  BillingListCompsitePage.prototype.created = function () {
    var pageType = this.$route.query.pageType;
    var tabList = this.showTabList.filter(function (item) {
      return item.value === pageType;
    });
    this.activeTab = tabList.length ? tabList[0].value.toString() : this.showTabList[0].value.toString();
  };

  BillingListCompsitePage = __decorate([Component({
    components: {
      BinllingList: BinllingList,
      TariffBinllingList: TariffBinllingList,
      TransportBinllingList: TransportBinllingList
    }
  })], BillingListCompsitePage);
  return BillingListCompsitePage;
}(Vue);

export default BillingListCompsitePage;